import { Form, TextArea } from "antd-mobile";
import React from "react";
import "./style.scss";

function CustomTextArea(props) {
  return (
    // <div className="agent-mobile-custom-textarea">
    <Form.Item {...props} className="agent-mobile-custom-textarea">
      <TextArea
        {...props}
        // autoSize={{ minRows: 3, maxRows: 5 }}
        rows={5}
      />
    </Form.Item>
    // </div>
  );
}

export default CustomTextArea;
